import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import axios, { isAxiosError } from 'axios'
import Loadingwrapper from '../../component/LoadingWrapper';
import DesignRecipeImage from './DesignRecipeImage';
import Select from 'react-dropdown-select';
import useAddImageToCollection from '../../hooks/useAddImageToCollection';
import useCollectionNames from '../../hooks/useCollectionNames';
import { CITIES, HeadersRanking, metaCategories, metaCategoriesMen, metaTags, TagsAllCategoriesRows } from '../../constants';
import { Lightbox } from 'yet-another-react-lightbox';
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import { useSelector } from 'react-redux';
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { SentenceCase } from '../../utility/helper_functions';

const SORTOPTIONS = [
  { value: "past-forecast-des", label: "Rank by Forecast Score High to Low of past 2-month forecast" },
  { value: "future-forecast-des", label: "Rank by Forecast Score High to Low of upcoming 2-month forecast" },
  { value: "past-forecast-asc", label: "Rank by Forecast Score Low to High of past 2-month forecast" },
  { value: "future-forecast-asc", label: "Rank by Forecast Score Low to High of upcoming 2-month forecast" },
  { value: 'recency', label: 'Rank by Recency' },
]

const DesignRecipeImages = ({ forAllImages = false }) => {
  const [searchParams, setSearchParams] = useSearchParams({ city: "" })
  const limit = 200
  const [socialImages, setSocialImages] = useState([])
  const [socialCount, setSocialCount] = useState(0)
  const [retailerImages, setRetailerImages] = useState([])
  const [retailerCount, setRetailerCount] = useState(0)
  const [maxPage, setMaxPage] = useState(1);
  const [loading, setLoading] = useState(true)
  const [filtersloading, setFiltersLoading] = useState(true)
  const [insertDatesOptions, setInsertDateOptions] = useState([])
  const [materialOptions, setMaterialOptions] = useState([])
  const [retailerOptions, setRetailerOptions] = useState([])
  const [SilhouetteOptions, setSilhouetteOptions] = useState([])
  const [socialSilhouetteCounts, setSocialSilhouetteCounts] = useState({})

  const [allCollectionNames, socialcollectionSets, retailercollectionSets, getCollectionNames] = useCollectionNames()
  const [page, setPage] = useState(1);
  const addImageToCollection = useAddImageToCollection()
  const [headers, setHeaders] = useState([])
  const [lightBoxImageIndex, setLightBoxImageIndex] = useState(null)
  const [retailerlightBoxImageIndex, setRetailerlightBoxImageIndex] = useState(null)
  const userLoggedIn = useSelector(state => state.userLoggedIn);
  const [startDateValue, setStartDateValue] = useState(null)
  const [endDateValue, setEndDateValue] = useState(null)
  const [collectionForSaveImages, setCollectionForSaveImages] = useState(null)

  const [futureForecastDateString, setFutureForecastDateString] = useState(``)
  const [pastForecastDateString, setPastForecastDateString] = useState(``)

  useEffect(() => {
    const todayDate = dayjs(new Date())
    const yesterday = dayjs(todayDate).add(-1, 'day')
    const future45day = dayjs(todayDate).add(45, 'day')
    const past45day = dayjs(todayDate).add(-46, 'day')

    setFutureForecastDateString(`${todayDate.format('DD MMM')}-${future45day.format('DD MMM')}`)
    setPastForecastDateString(`${past45day.format('DD MMM')}-${yesterday.format('DD MMM')}`)
  }, [])


  const [listOfAllPossibleHeaders, setListOfAllPossibleHeaders] = useState(['SILHOUETTE'])
  const firstLightbox = useRef(false)

  const eventListenerFunc = (e) => {
    setLightBoxImageIndex(null)
    setRetailerlightBoxImageIndex(null)
    window.removeEventListener('popstate', eventListenerFunc)

  }
  useEffect(() => {
    if (lightBoxImageIndex !== null || retailerlightBoxImageIndex !== null) {
      if (!firstLightbox.current) {
        firstLightbox.current = true
        setSearchParams(prev => {
          prev.set('lightbox', 'show')
          return prev
        })
        window.addEventListener('popstate', eventListenerFunc)
      }
    } else {
      firstLightbox.current = false
    }

  }, [lightBoxImageIndex, retailerlightBoxImageIndex])
  useEffect(() => {
    let headersList = new Set(listOfAllPossibleHeaders);
    for (let tag in metaTags) {
      headersList.add(tag)
    }
    headersList.add('COLOR')
    headersList.add('MULTICOLOR')
    setListOfAllPossibleHeaders([...headersList.values()])
  }, [])

  useEffect(() => {
    setSearchParams(prev => {
      if (prev.get('city') && prev.get('city') != '') {
        prev.set('time', '180 days')
      }
      return prev
    })
  }, [searchParams.get('city')])

  const socialAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, socialcollectionSets, 'social', getCollectionNames);
  }

  const retailerAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, retailercollectionSets, 'retailer', getCollectionNames);
  }
  useEffect(() => {
    setSearchParams(prev => {
      prev.set('gender', prev.get('gender') || (forAllImages ? 'M' : 'F'))
      prev.set('category', prev.get('category') || 'All')
      prev.set('tab', prev.get('tab') || (prev.get('gender') == 'M' ? 'both' : 'social'))
      prev.set('sort', "past-forecast-des")
      prev.set('geography', prev.get('geography') || 'All')
      prev.set('time', prev.get('time') || '')
      prev.set('page', prev.get('page') || '1')
      prev.set('headers', prev.get('headers') || '')
      return prev;
    })
  }, [])


  useEffect(() => {
    const tab = searchParams.get('tab')
    setMaxPage(tab == 'social' ? Math.ceil(socialCount / limit) : tab == 'retailer' ? Math.ceil(retailerCount / limit) : Math.ceil(Math.max(socialCount, retailerCount) / limit))
  }, [retailerCount, socialCount, searchParams.get('tab')])
  /*
    const getHeaders = (signal) => {
      axios.get(`/social-trends-v2-api/design-recipe-images-headerwise-counts/${searchParams.get('tab') || 'social'}?gender=${searchParams.get('gender') || 'Female'}&category=${encodeURIComponent(searchParams.get('category'))}&sort=${searchParams.get('sort')}&geography=${searchParams.get('geography') || ''}&time=${searchParams.get('time') || ''}&page=${searchParams.get('page') || '1'}&retailer=${searchParams.get('retailer') || ''}&insertDate=${searchParams.get('insertDate') || ''}&silhouette=${searchParams.get('silhouette') || ''}&limit=${limit}&headers=${searchParams.get('headers') || ''}`, { signal })
        .then(res => {
          setHeaders(res.data)
        })
        .catch(err => {
          console.log(err)
        }).finally(() => {
        })
    }
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    getHeaders(signal)
    return () => {
      // Cancel the request when the component unmounts
      controller.abort();
    };
  }, [searchParams.get('tab'), searchParams.get('page'), searchParams.get('geography'), searchParams.get('time'), searchParams.get('gender'), searchParams.get('category'), searchParams.get('silhouette'), searchParams.get('insertDate'), searchParams.get('retailer')])
    */

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    getImages(signal)
    return () => {
      // Cancel the request when the component unmounts
      controller.abort();
    };
  }, [searchParams.get('tab'), searchParams.get('page'), searchParams.get('geography'), searchParams.get('time'), searchParams.get('gender'), searchParams.get('category'), searchParams.get('silhouette'), searchParams.get('insertDate'), searchParams.get('retailer'), searchParams.get('sort'), searchParams.get('headers'), listOfAllPossibleHeaders, searchParams, startDateValue, endDateValue])
  const [isFirstRender, setIsFirstRender] = useState(true)
  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false)
      return
    }
    setSearchParams(prev => {
      prev.set('page', '1')
      return prev;
    })

  }, [searchParams.get('tab'), searchParams.get('geography'), searchParams.get('time'), searchParams.get('gender'), searchParams.get('category'), searchParams.get('silhouette'), searchParams.get('insertDate'), searchParams.get('retailer'), searchParams.get('sort'), listOfAllPossibleHeaders])
  const getHeaderString = () => {
    let headerString = ''
    let headerList = []
    listOfAllPossibleHeaders.forEach(header => {
      if (searchParams.get(header)) {
        headerList.push(encodeURIComponent(header))
        headerString = headerString + `&${encodeURIComponent(header)}=${encodeURIComponent(searchParams.get(header))}`
      }
    })
    return [headerList, headerString];
  }

  const getImages = (signal) => {
    setLoading(true)
    const [headerList, headerString] = getHeaderString()
    axios.get(`/social-trends-v2-api/design-recipe-images${searchParams.get('category') == 'All' ? '-all' : ''}/${searchParams.get('tab') || 'social'}?gender=${searchParams.get('gender') || 'Female'}&category=${encodeURIComponent(searchParams.get('category'))}&sort=${searchParams.get('sort')}&geography=${searchParams.get('geography') || ''}&time=${searchParams.get('time') || ''}&page=${searchParams.get('page') || '1'}&retailer=${searchParams.get('retailer') || ''}&insertDate=${searchParams.get('insertDate') || ''}&silhouette=${encodeURIComponent(searchParams.get('silhouette') || '')}&limit=${limit}&headers=${headerList.join(',,')}${headerString}&material=${searchParams.get('material') || ''}${startDateValue ? `&startDate=${dayjs(startDateValue).format('DD-MM-YYYY')}` : ''}${endDateValue ? `&endDate=${dayjs(endDateValue).format('DD-MM-YYYY')}` : ''}&city=${searchParams.get("city") || ''}`, { signal })
      .then(res => {
        const urls = new Set()
        const retailerImages = res.data.retailerImages.filter(p => {
          const productUrlPath = p.product_url.split('?')[0];
          if (urls.has(productUrlPath)) {
            return false;
          }
          urls.add(productUrlPath);
          return true
        })

        for (let image of retailerImages) {
          if (image.categoryTrends && Object.keys(image.categoryTrends)) {
            image.categoryTrends = image.categoryTrends[searchParams.get('category')] ? image.categoryTrends[searchParams.get('category')] : Object.values(image.categoryTrends)[0]
          }
        }
        setSocialImages(res.data.socialImages)
        setSocialCount(res.data.socialCount)
        setRetailerImages(retailerImages)
        setRetailerCount(res.data.retailerCount)
        setLoading(false)
      })
      .catch(err => {
        if (!isAxiosError(err)) {
          console.log(err)
        }
      }).finally(() => {
      })

  }

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    getRetailerFilterCounts(signal)
    return () => {
      // Cancel the request when the component unmounts
      controller.abort();
    };
  }, [searchParams.get('gender'), searchParams.get('category'), searchParams.get('silhouette'), searchParams.get('insertDate'), searchParams.get('retailer'), searchParams.get('sort'), searchParams.get('time'), searchParams.get('headers'), searchParams, listOfAllPossibleHeaders])

  const getRetailerFilterCounts = (signal) => {
    const [headerList, headerString] = getHeaderString()
    setFiltersLoading(true)
    axios.get(`/social-trends-v2-api/design-recipe-image-counts?gender=${searchParams.get('gender') || 'Female'}&category=${encodeURIComponent(searchParams.get('category'))}&geography=${searchParams.get('geography') || ''}&time=${searchParams.get('time') || ''}&insertDate=${searchParams.get('insertDate') || ''}&retailer=${searchParams.get('retailer') || ''}&silhouette=${searchParams.get('silhouette') || ''}&headers=${headerList.join(',,')}${headerString}&isallcategories=${forAllImages}&city=${searchParams.get('city') || ''}`, { signal })
      .then(res => {
        setRetailerOptions(res.data.retailerCounts.map(t => ({ ...t, label: `${t.retailer} (${t.count})` })))
        setMaterialOptions(res.data.materialCounts.map(t => ({ ...t, label: `${t.material} (${t.count})` })))
        setInsertDateOptions(res.data.insertCounts.map(t => ({ ...t, label: `${t.insertDate} (${t.count})` })))
        const socialSilhouetteCounts = res.data.socialSilhouetteCounts
        const socialSilhouetteCountsObj = {}
        if (socialSilhouetteCounts) {
          socialSilhouetteCounts.forEach(c => {
            socialSilhouetteCountsObj[c.silhouette] = c.count
          })

        }
        setHeaders(res.data.headerCounts)
        setSocialSilhouetteCounts(socialSilhouetteCountsObj)
        const retailerSilhouettes = new Set(res.data.silhouetteCounts.map(t => t.silhouette))
        const silhouetteCountsTemp = [
          ...res.data.silhouetteCounts.map(t => ({ silhouette: t.silhouette, socialCount: socialSilhouetteCountsObj[t.silhouette] || 0, retailerCount: t.count })),
          ...res.data.socialSilhouetteCounts.filter(t => !retailerSilhouettes.has(t.silhouette))
            .map(t => ({ silhouette: t.silhouette, socialCount: t.count, retailerCount: 0 }))
        ]
        if (searchParams.get('tab') == 'both') {
          setSilhouetteOptions(silhouetteCountsTemp.map(t => ({ silhouette: t.silhouette, label: `${t.silhouette} (${t.socialCount} and ${t.retailerCount})`, count: t.count })))
        } else {
          const isSocialTab = searchParams.get('tab') == 'social'
          setSilhouetteOptions(silhouetteCountsTemp.map(t => ({ silhouette: t.silhouette, label: `${t.silhouette} (${isSocialTab ? t.socialCount : t.retailerCount})`, count: isSocialTab ? t.socialCount : t.retailerCount })).filter(c => c.count > 0))
        }
        setFiltersLoading(false)
      })
      .catch(err => {
        if (!isAxiosError(err)) {
          console.error(err)
        }
      })
  }

  return <div id='#design-recipe-images-wrapper'>
    <h2 className='text-center m-2 font-semibold text-lg'>{searchParams.get('category')} Product Leaderboard</h2>
    <div className='mx-5 max-[805px]:mx-0 mb-1 flex sticky top-12 mt-2 bg-white justify-between items-center z-10 flex-wrap text-xs'>

      <div className='flex mx-5 flex-wrap'>
        {
          forAllImages ? <>
            <div className='m-1'>
              <Select
                style={{ maxWidth: "100vw" }}
                key={'gender' + window.location.href}
                placeholder={'Gender'}
                options={[{ value: 'F', label: 'Female' }, { value: 'M', label: 'Male' }]}
                valueField={'value'}
                labelField={'label'}
                values={searchParams.get('gender') == 'F' ? [{ value: 'F', label: 'Female' }] : [{ value: 'M', label: 'Male' }]}
                onChange={(values) => setSearchParams(prev => {
                  prev.set('gender', values[0].value)
                  return prev;
                })}
                searchable={false}
                className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
                wrapperClassName='m-0 lg:m-2 w-40 '
              />
            </div>
            <div className='m-1'>
              <Select
                style={{ maxWidth: "100vw" }}
                key={'category' + window.location.href}
                placeholder={'Category'}
                options={[{ value: 'All', label: 'All Categories' },
                ...((searchParams.get('gender') == 'M' ? metaCategoriesMen : metaCategories).map(cat => ({ value: cat, label: cat })))]}
                values={[{ value: searchParams.get('category'), label: searchParams.get('category') == 'All' ? 'All Categories' : searchParams.get('category') }]}
                onChange={(values) => setSearchParams(prev => {
                  prev.set('category', values[0].value)
                  return prev;
                })}
                searchable={false}
                className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
                wrapperClassName='m-0 lg:m-2 w-40 '
              />
            </div>
          </>
            : null
        }
        {
          !forAllImages ?

            <div className='m-1'>
              <Select
                style={{ maxWidth: "100vw" }}
                key={'sort' + window.location.href}
                placeholder={'Sort'}
                options={SORTOPTIONS}
                values={SORTOPTIONS.filter(t => searchParams.get('sort') == t.value)}
                onChange={(values) => setSearchParams(prev => {
                  prev.set('sort', values[0].value)
                  return prev;
                })}
                searchable={false}
                className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
                wrapperClassName='m-0 lg:m-2 w-40 '
              />
            </div>
            : null
        }

        <div className='m-1'>
          <Select
            style={{ maxWidth: "100vw" }}
            key={'tab' + window.location.href}
            placeholder={'Channel'}
            options={[{ value: 'both', label: 'Social + Retailer' }, { value: 'social', label: 'Social' }, { value: 'retailer', label: 'Retailer' }]}
            values={[{ value: searchParams.get('tab'), label: searchParams.get('tab') == 'both' ? 'Social + Retailer' : searchParams.get('tab') == 'social' ? 'Social' : 'Retailer' }]}
            onChange={(values) => setSearchParams(prev => {
              prev.set('tab', values[0].value)
              return prev;
            })}
            searchable={false}
            className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
            wrapperClassName='m-0 lg:m-2 min-w-40 '
            contentRenderer={({ props, state, methods }) => {
              return <div>Channel :{state.values ? state.values[0].label : null}</div>
            }}
          />
        </div>
        <div className='m-1'>
          <Select
            style={{ maxWidth: "100vw" }}
            key={'time' + window.location.href}
            placeholder={'Timeframe'}
            options={[{ value: '', label: 'All Time' }, ...(['7', '15', '30', '45', '60', '90', '180'].map(t => ({ value: `${t} days`, label: `${t} days` })))]}
            values={[{ value: searchParams.get('time'), label: searchParams.get('time') == '' ? 'All Time' : searchParams.get('time') }]}
            onChange={(values) => setSearchParams(prev => {
              prev.set('time', values[0].value)
              return prev;
            })}
            searchable={false}
            className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
            wrapperClassName='m-0 lg:m-2 '
            contentRenderer={({ props, state, methods }) => {
              return <div>Timeframe :{state.values && state.values[0] ? state.values[0].label : null}</div>
            }}
          />
        </div>

        {searchParams.get('tab') != 'social' ? <>
          <div className=' m-1'>
            <Select
              style={{ maxWidth: "100vw" }}
              key={'retailer' + window.location.href}
              placeholder={'Retailer'}
              options={[{ retailer: 'All', label: 'All', count: insertDatesOptions.reduce((prev, currentElem) => (prev + currentElem.count), 0) }, ...retailerOptions]}
              valueField={'retailer'}
              labelField={'label'}
              multi={true}
              values={retailerOptions.filter((obj) => ((searchParams.get('retailer') || '').split(',,').includes(obj.retailer)))}
              onChange={(values) => setSearchParams(prev => {
                let next;
                if (values.length == 0 || values[values.length - 1].retailer == 'All' || values.length == retailerOptions.length) {
                  next = ''
                } else {
                  next = values.map(p => p.retailer).join(',,')
                }
                prev.set('retailer', next)
                return prev;
              })}
              searchable={false}
              className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0 lg:m-1 bg-slate-200 mr-2 min-w-40'
              wrapperClassName='m-0 lg:m-2 w-full'
              contentRenderer={({ props, state, methods }) => {
                return <div>{state.values && state.values.length > 0 ? <div className='flex flex-wrap'><span className='p-1 m-0.5'>Retailer Name :</span>{state.values.map(v => <div className='p-1 rounded text-white m-0.5 bg-[#0074d9]'>{v.label}</div>)}</div> : "Retailer Name"}</div>
              }}
            />
          </div>
        </> : null}
        {searchParams.get('tab') != 'retailer' ? <>
          <div className='m-1'>
            <Select
              style={{ maxWidth: "100vw" }}
              key={'geography' + window.location.href}
              placeholder={'Geography'}
              options={[{ value: 'All', label: 'All geography' }, ...(['Asian', 'Indian', 'Western', 'Asian,Western'].map(t => ({ value: t, label: t == 'Asian,Western' ? 'Asian + Western' : t })))]}
              values={[{ value: searchParams.get('geography'), label: searchParams.get('geography') == 'All' ? 'All geography' : searchParams.get('geography') == 'Asian,Western' ? 'Asian + Western' : searchParams.get('geography') }]}
              onChange={(values) => setSearchParams(prev => {
                prev.set('geography', values[0].value)
                return prev;
              })}
              searchable={false}
              className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
              wrapperClassName='m-0 lg:m-2 w-40 '
            />
          </div>

          <div className='m-1'>
            <Select
              style={{ maxWidth: "100vw" }}
              key={'city' + window.location.href}
              placeholder={'City'}
              options={[{ value: '', label: 'All Cities' }, ...(CITIES.map(t => ({ value: t, label: SentenceCase(t) })))]}
              values={[{ value: searchParams.get('city'), label: searchParams.get('city') == '' ? 'All Cities' : SentenceCase(searchParams.get('city')) }]}
              onChange={(values) => setSearchParams(prev => {
                prev.set('city', values[0].value)
                return prev;
              })}
              searchable={false}
              className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
              wrapperClassName='m-0 lg:m-2 w-40 '
            />
          </div>
        </> : null}

        {
          userLoggedIn.curator && !forAllImages && searchParams.get('tab') != 'social' ? <>
            <div className=' m-1'>
              <Select
                style={{ maxWidth: "100vw" }}
                key={'insertDate' + window.location.href}
                placeholder={'Retailer Insert Date'}
                options={[{ insertDate: 'All', label: 'All', count: insertDatesOptions.reduce((prev, currentElem) => (prev + currentElem.count), 0) }, ...insertDatesOptions]}
                valueField={'insertDate'}
                labelField={'label'}
                multi={true}
                values={insertDatesOptions.filter((obj) => ((searchParams.get('insertDate') || '').split(',,').includes(obj.insertDate)))}
                onChange={(values) => setSearchParams(prev => {
                  let next;
                  if (values.length == 0 || values[values.length - 1].insertDate == 'All' || values.length == insertDatesOptions.length) {
                    next = ''
                  } else {
                    next = values.map(p => p.insertDate).join(',,')
                  }
                  prev.set('insertDate', next)
                  return prev;
                })}
                searchable={false}
                className='px-2 rounded py-1 border-slate-300 border  bg-slate-200  min-w-40 flex flex-wrap lg:m-1 py-0 lg:py-1'
                wrapperClassName='m-0 lg:m-2 w-40 '
              />
            </div>

          </> : null
        }
        {
          false && userLoggedIn.curator && !forAllImages ?
            <div className='m-1'>
              <Select
                style={{ maxWidth: "100vw" }}
                key={'sort' + window.location.href}
                placeholder={'Sort'}
                options={[{ value: 'rog', label: 'ROG' }, { value: 'recency', label: 'Recency' }, { value: 'success', label: 'Success score' }, { value: "forecast", label: "Demand forecast score" }]}
                values={[{ value: 'rog', label: 'ROG' }, { value: 'recency', label: 'Recency' }, { value: 'success', label: 'Success score' }].filter(t => searchParams.get('sort') == t.value)}
                onChange={(values) => setSearchParams(prev => {
                  prev.set('sort', values[0].value)
                  return prev;
                })}
                searchable={false}
                className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
                wrapperClassName='m-0 lg:m-2 w-40 '
              />
            </div>
            : null
        }


      </div>
      {userLoggedIn.curator ? <div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker', 'DatePicker']}>
            <DatePicker
              label="Start Date"
              format='DD-MM-YYYY'
              value={startDateValue}
              onChange={(newValue) => setStartDateValue(newValue)}
            />
            <DatePicker
              label="End Date"
              value={endDateValue}
              format='DD-MM-YYYY'
              onChange={(newValue) => setEndDateValue(newValue)}
            />
          </DemoContainer>
        </LocalizationProvider>
      </div>
        : null}

      <div className=' hidden lg:flex justify-end w-full shrink-0 lg:w-auto lg:shrink'>
        <button className='hover:bg-blue-700 text-white disabled:opacity-50 bg-blue-500 px-7 py-1 mr-2 rounded-3xl' disabled={parseInt(searchParams.get('page') || '1') <= 1}
          onClick={() => {
            setSearchParams(prev => {
              prev.set('page', parseInt(prev.get('page') || '1') - 1);
              return prev
            })
          }}>prev</button>
        <span className='mr-2'>{searchParams.get('page') || 1}/{maxPage}</span>
        <button className='hover:bg-blue-700 text-white disabled:opacity-50 bg-blue-500 px-7 py-1 mr-2 rounded-3xl' disabled={parseInt(searchParams.get('page') || '1') >= maxPage}
          onClick={() => {
            setSearchParams(prev => {
              prev.set('page', parseInt(prev.get('page') || '1') + 1);
              return prev
            })
          }}>next</button>
      </div>
    </div>
    <div>{!forAllImages && !filtersloading ?
      <div className='flex flex-wrap px-4 text-xs'>
        {searchParams.get('category') && searchParams.get('category') != 'All' ? <div className='relative mx-0.5 my-0.5 min-w-[12vw] shrink-0' >
          <Select
            style={{ maxWidth: "100vw" }}
            key={'silhouette' + window.location.href}
            placeholder={'SILHOUETTE'}
            options={[{ silhouette: 'All', label: 'All', count: SilhouetteOptions.reduce((prev, currentElem) => (prev + currentElem.count), 0) }, ...SilhouetteOptions]}
            valueField={'silhouette'}
            labelField={'label'}
            multi={true}
            values={SilhouetteOptions.filter((obj) => ((searchParams.get('silhouette') || '').split(',,').includes(obj.silhouette)))}
            onChange={(values) => setSearchParams(prev => {
              let next;
              if (values.length == 0 || values[values.length - 1].silhouette == 'All' || values.length == SilhouetteOptions.length) {
                next = ''
              } else {
                next = values.map(p => p.silhouette).join(',,')
              }
              prev.set('silhouette', next)
              return prev;
            })}
            searchable={false}
            className='px-1 rounded py-0.5 border-slate-300 border  bg-slate-200 mr-0.5  flex flex-wrap text-black min-w-40'
            wrapperClassName='m-2 w-40 text-black '
          />
        </div>
          : null}

        {searchParams.get('gender') == 'M' && !["Ethinic Wear", "Footwear", "Bags", "Sunglasses", "Caps & Hats", "Belt"].includes(searchParams.get('category')) ? <div className=' mx-1 min-w-[12vw] shrink-0'>
          <Select
            style={{ maxWidth: "100vw" }}
            key={'material' + window.location.href}
            placeholder={'MATERIAL (from retailer\'s page)'}
            options={[{ material: 'All', label: 'All' }, ...materialOptions]}
            valueField={'material'}
            labelField={'label'}
            multi={true}
            values={materialOptions.filter((obj) => ((searchParams.get('material') || '').split(',,').includes(obj.material)))}
            onChange={(values) => setSearchParams(prev => {
              let next;
              if (values.length == 0 || values[values.length - 1].material == 'All' || values.length == materialOptions.length) {
                next = ''
              } else {
                next = values.map(p => p.material).join(',,')
              }
              prev.set('material', next)
              return prev;
            })}
            searchable={false}
            className='px-2 rounded py-1 border-slate-300 border m-0.5 bg-slate-200 mr-2 min-w-40 flex flex-wrap'
            wrapperClassName='m-2 w-40'
          />
        </div>
          : null}
        {headers
          .filter(t => (searchParams.get('category') != 'Ethinic Wear' || ['COLOR', 'ETHINIC WEAR', 'KURTA SILHOUETTE', 'NECKLINE'].includes(t.tag)))
          .sort((a, b) => {
            return HeadersRanking[searchParams.get('category')] ? HeadersRanking[searchParams.get('category')][a.tag] - HeadersRanking[searchParams.get('category')][b.tag] : 1
          }).map(header => <div className='relative mx-0.5 my-0.5 min-w-[12vw] shrink-0' key={header.tag}>
            <Select
              style={{ maxWidth: "100vw" }}
              key={header.tag + window.location.href}
              placeholder={header.tag}
              options={header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ' and ' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` }))}
              valueField={'value'}
              labelField={'label'}
              multi={true}
              values={searchParams.get(header.tag) ?
                header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ',' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` })).filter(t => (searchParams.get(header.tag).split(',,').includes(t.value)))
                : []}
              onChange={(values) => setSearchParams(prev => {
                if (values.length == 0) {
                  const headersList = prev.get('headers').split(',,').filter(h => h != header.tag)
                  prev.delete(header.tag)
                } else {
                  prev.set(header.tag, values.map(v => v.value).join(',,'))
                }
                return prev;
              })}
              searchable={false}
              className='px-1 rounded py-0.5 border-slate-300 border  bg-slate-200 mr-0.5  flex flex-wrap text-black min-w-40'

              wrapperClassName='m-2 w-40 text-black'
            />
          </div>)}
      </div>
      : null}
    </div>
    {!filtersloading ? <>
      <div>{forAllImages ?
        <div className='flex flex-wrap px-4 text-xs'>
          {searchParams.get('category') && searchParams.get('category') != 'All' ? <div className='relative mx-0.5 my-0.5 min-w-[12vw] shrink-0' >
            <Select
              style={{ maxWidth: "100vw" }}
              key={'silhouette' + window.location.href}
              placeholder={'SILHOUETTE'}
              options={[{ silhouette: 'All', label: 'All', count: SilhouetteOptions.reduce((prev, currentElem) => (prev + currentElem.count), 0) }, ...SilhouetteOptions]}
              valueField={'silhouette'}
              labelField={'label'}
              multi={true}
              values={SilhouetteOptions.filter((obj) => ((searchParams.get('silhouette') || '').split(',,').includes(obj.silhouette)))}
              onChange={(values) => setSearchParams(prev => {
                let next;
                if (values.length == 0 || values[values.length - 1].silhouette == 'All' || values.length == SilhouetteOptions.length) {
                  next = ''
                } else {
                  next = values.map(p => p.silhouette).join(',,')
                }
                prev.set('silhouette', next)
                return prev;
              })}
              searchable={false}
              className='px-1 rounded py-0.5 border-slate-300 border  bg-slate-200 mr-0.5  flex flex-wrap text-black min-w-40'

              wrapperClassName='m-2 w-40 text-black'
            />
          </div>
            : null}
          {headers
            .filter(t => (searchParams.get('category') != 'Ethinic Wear' || ['COLOR', 'ETHINIC WEAR', 'KURTA SILHOUETTE', 'NECKLINE'].includes(t.tag)))
            .filter(t => TagsAllCategoriesRows[0][t.tag])
            .sort((a, b) => {
              return TagsAllCategoriesRows[0][a.tag] - TagsAllCategoriesRows[0][b.tag]
            }).map(header => <div className='relative mx-0.5 my-0.5 min-w-[12vw] shrink-0' key={header.tag}>
              <Select
                style={{ maxWidth: "100vw" }}
                key={header.tag + window.location.href}
                placeholder={header.tag}
                options={header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ' and ' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` }))}
                valueField={'value'}
                labelField={'label'}
                multi={true}
                values={searchParams.get(header.tag) ?
                  header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ',' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` })).filter(t => (searchParams.get(header.tag).split(',,').includes(t.value)))
                  : []}
                onChange={(values) => setSearchParams(prev => {
                  if (values.length == 0) {
                    prev.delete(header.tag)
                  } else {
                    prev.set(header.tag, values.map(v => v.value).join(',,'))
                  }
                  return prev;
                })}
                searchable={false}
                className='px-1 rounded py-0.5 border-slate-300 border  bg-slate-200 mr-0.5  flex flex-wrap text-black min-w-40'

                wrapperClassName='m-2 w-40 text-black'
              />
            </div>)}
          {searchParams.get('gender') == 'M' && !["Ethinic Wear", "Footwear", "Bags", "Sunglasses", "Caps & Hats", "Belt"].includes(searchParams.get('category')) ? <div className=' mx-1 min-w-[12vw] shrink-0'>
            <Select
              style={{ maxWidth: "100vw" }}
              key={'material' + window.location.href}
              placeholder={'MATERIAL (RETAILER ONLY)'}
              options={[{ material: 'All', label: 'All' }, ...materialOptions]}
              valueField={'material'}
              labelField={'label'}
              multi={true}
              values={materialOptions.filter((obj) => ((searchParams.get('material') || '').split(',,').includes(obj.material)))}
              onChange={(values) => setSearchParams(prev => {
                let next;
                if (values.length == 0 || values[values.length - 1].material == 'All' || values.length == materialOptions.length) {
                  next = ''
                } else {
                  next = values.map(p => p.material).join(',,')
                }
                prev.set('material', next)
                return prev;
              })}
              searchable={false}
              className='px-2 rounded py-1 border-slate-300 border  bg-slate-200  min-w-40 flex flex-wrap'
              wrapperClassName=' w-40'
            />
          </div>
            : null}
        </div>
        : null}
      </div>


      <div>{forAllImages ?
        <div className='flex flex-wrap px-4 text-xs'>
          {headers
            .filter(t => (searchParams.get('category') != 'Ethinic Wear' || ['COLOR', 'ETHINIC WEAR', 'KURTA SILHOUETTE', 'NECKLINE'].includes(t.tag)))
            .filter(t => TagsAllCategoriesRows[1][t.tag])
            .sort((a, b) => {
              return TagsAllCategoriesRows[1][a.tag] - TagsAllCategoriesRows[1][b.tag]
            }).map(header => <div className='relative mx-0.5 my-0.5 min-w-[12vw] shrink-0' key={header.tag}>
              <Select
                style={{ maxWidth: "100vw" }}
                key={header.tag + window.location.href}
                placeholder={header.tag}
                options={header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ' and ' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` }))}
                valueField={'value'}
                labelField={'label'}
                multi={true}
                values={searchParams.get(header.tag) ?
                  header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ',' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` })).filter(t => (searchParams.get(header.tag).split(',,').includes(t.value)))
                  : []}
                onChange={(values) => setSearchParams(prev => {
                  if (values.length == 0) {
                    prev.delete(header.tag)
                  } else {
                    prev.set(header.tag, values.map(v => v.value).join(',,'))
                  }
                  return prev;
                })}
                searchable={false}
                className='px-1 rounded py-0.5 border-slate-300 border  bg-slate-200 mr-0.5  flex flex-wrap text-black min-w-40'

                wrapperClassName='m-2 w-40 text-black'
              />
            </div>)}
        </div>
        : null}
      </div>
      <div>{forAllImages ?
        <div className='flex flex-wrap px-4 text-xs'>
          {headers
            .filter(t => (searchParams.get('category') != 'Ethinic Wear' || ['COLOR', 'ETHINIC WEAR', 'KURTA SILHOUETTE', 'NECKLINE'].includes(t.tag)))
            .filter(t => TagsAllCategoriesRows[2][t.tag])
            .sort((a, b) => {
              return TagsAllCategoriesRows[2][a.tag] - TagsAllCategoriesRows[2][b.tag]
            }).map(header => <div className='relative mx-0.5 my-0.5 min-w-[12vw] shrink-0' key={header.tag}>
              <Select
                style={{ maxWidth: "100vw" }}
                key={header.tag + window.location.href}
                placeholder={header.tag}
                options={header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ' and ' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` }))}
                valueField={'value'}
                labelField={'label'}
                multi={true}
                values={searchParams.get(header.tag) ?
                  header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ',' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` })).filter(t => (searchParams.get(header.tag).split(',,').includes(t.value)))
                  : []}
                onChange={(values) => setSearchParams(prev => {
                  if (values.length == 0) {
                    prev.delete(header.tag)
                  } else {
                    prev.set(header.tag, values.map(v => v.value).join(',,'))
                  }
                  return prev;
                })}
                searchable={false}
                className='px-1 rounded py-0.5 border-slate-300 border  bg-slate-200 mr-0.5  flex flex-wrap text-black min-w-40'

                wrapperClassName='m-2 w-40 text-black'
              />
            </div>)}

        </div>
        : null}
      </div>
      <div>{forAllImages ?
        <div className='flex flex-wrap px-4 text-xs'>
          {headers
            .filter(t => (searchParams.get('category') != 'Ethinic Wear' || ['COLOR', 'ETHINIC WEAR', 'KURTA SILHOUETTE', 'NECKLINE'].includes(t.tag)))
            .filter(t => TagsAllCategoriesRows[3][t.tag])
            .sort((a, b) => {
              return TagsAllCategoriesRows[3][a.tag] - TagsAllCategoriesRows[3][b.tag]
            }).map(header => <div className='relative mx-0.5 my-0.5 min-w-[12vw] shrink-0' key={header.tag}>
              <Select
                style={{ maxWidth: "100vw" }}
                key={header.tag + window.location.href}
                placeholder={header.tag}
                options={header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ' and ' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` }))}
                valueField={'value'}
                labelField={'label'}
                multi={true}
                values={searchParams.get(header.tag) ?
                  header.values.map(item => ({ value: item.value, label: `${item.value} (${searchParams.get('tab') != 'retailer' ? item.socialCount : ''}${searchParams.get('tab') == 'both' ? ',' : ''}${searchParams.get('tab') != 'social' ? item.retailerCount : ''})` })).filter(t => (searchParams.get(header.tag).split(',,').includes(t.value)))
                  : []}
                onChange={(values) => setSearchParams(prev => {
                  if (values.length == 0) {
                    prev.delete(header.tag)
                  } else {
                    prev.set(header.tag, values.map(v => v.value).join(',,'))
                  }
                  return prev;
                })}
                searchable={false}
                className='px-1 rounded py-0.5 border-slate-300 border  bg-slate-200 mr-0.5  flex flex-wrap text-black min-w-40 '
                wrapperClassName='m-2 w-40 text-black'
              />
            </div>)}

        </div>
        : null}
      </div>
    </> : <div className='font-medium ml-4'> Loading Filters…</div>}
    {userLoggedIn && userLoggedIn.curator ? <div className='flex justify-end'>
      <select
        className='px-2 py-1 rounded mr-4'
        value={collectionForSaveImages ? collectionForSaveImages._id : ''}
        onChange={e => {
          const id = e.target.value
          const matchingCollection = allCollectionNames.filter(c => c._id == id)
          setCollectionForSaveImages(matchingCollection[0] || null)
        }}>
        <option value={''} disabled>--Select collection--</option>
        {allCollectionNames.map(c => <option value={c._id} key={c._id}>{c.collectionName}</option>)}

      </select>

    </div> : null}
    <Loadingwrapper loading={loading}>
      <div className='flex w-screen'>
        {
          searchParams.get('tab') != 'retailer' ? <div className='w-full'>
            <div className='m-0.5 lg:m-2 justify-center flex'><img src='/social-logo.png' className='h-3 lg:h-5' /><span className='text-xs lg:text-sm '>({socialCount} products)</span></div>
            <div className='flex w-full flex-wrap justify-center'>
              {
                socialImages.map((image, index) => <DesignRecipeImage image={image} index={index} type={'social'} isBoth={searchParams.get('tab') == 'both'} allCollectionNames={allCollectionNames} addImageToCollection={socialAddImageToCollectionWrapper} collectionSets={socialcollectionSets} fetchCollections={getCollectionNames} gender={searchParams.get('gender')} category={searchParams.get('category')} setLightBoxImageIndex={setLightBoxImageIndex} futureForecastDateString={futureForecastDateString} pastForecastDateString={pastForecastDateString} />)
              }
            </div>

          </div> : null
        }
        {searchParams.get('tab') == 'both' ? <div className='w-0 border border-black'></div> : null}
        {
          searchParams.get('tab') != 'social' ? <div className='w-full'>
            <div className='m-0.5 lg:m-2 justify-center flex'><img src='/retailer-logo.png' className='h-3 lg:h-5' /><span className='text-xs lg:text-sm '>({retailerCount} products)</span></div>
            <div className='flex w-full flex-wrap justify-center'>
              {
                retailerImages.map((image, index) => <DesignRecipeImage image={image} index={index} type={'retailer'} isBoth={searchParams.get('tab') == 'both'} allCollectionNames={allCollectionNames} addImageToCollection={retailerAddImageToCollectionWrapper} collectionSets={retailercollectionSets} fetchCollections={getCollectionNames} gender={searchParams.get('gender')} category={searchParams.get('category')} setLightBoxImageIndex={setRetailerlightBoxImageIndex} futureForecastDateString={futureForecastDateString} pastForecastDateString={pastForecastDateString} />)
              }
            </div>

          </div> : null
        }

      </div>
    </Loadingwrapper>
    {loading ? <p className='text-center text-green-600 font-semibold text-sm mt-10 mb-60'>Computing, Ranking...{searchParams.get('category') == 'Dresses' ? '(E.T. 2 minutes) ' : ''}Please wait</p> : null}


    <div className=' flex lg:hidden justify-center w-full shrink-0 lg:w-auto lg:shrink'>
      <button className='hover:bg-blue-700 text-white disabled:opacity-50 bg-blue-500 px-7 py-1 mr-2 rounded-3xl' disabled={parseInt(searchParams.get('page') || '1') <= 1}
        onClick={() => {
          setSearchParams(prev => {
            prev.set('page', parseInt(prev.get('page') || '1') - 1);
            return prev
          })
        }}>prev</button>
      <span className='mr-2'>{searchParams.get('page') || 1}/{maxPage}</span>
      <button className='hover:bg-blue-700 text-white disabled:opacity-50 bg-blue-500 px-7 py-1 mr-2 rounded-3xl' disabled={parseInt(searchParams.get('page') || '1') >= maxPage}
        onClick={() => {
          setSearchParams(prev => {
            prev.set('page', parseInt(prev.get('page') || '1') + 1);
            return prev
          })
        }}>next</button>
    </div>
    <Lightbox
      open={lightBoxImageIndex != null}
      close={() => {
        setLightBoxImageIndex(null)
      }}
      toolbar={{
        buttons: userLoggedIn && userLoggedIn.curator && collectionForSaveImages && lightBoxImageIndex != null ? [
          <button key="my-button" type="button" className={`yarl__button ${socialcollectionSets[collectionForSaveImages._id].has(socialImages[lightBoxImageIndex % socialImages.length]._id) ? 'bg-red-500' : 'bg-blue-600'}`}
            onClick={(e) => {
              socialAddImageToCollectionWrapper(socialImages[lightBoxImageIndex % socialImages.length], collectionForSaveImages._id)
            }}>{socialcollectionSets[collectionForSaveImages._id].has(socialImages[lightBoxImageIndex % socialImages.length]._id) ? 'Unsave' : 'Save'} in {collectionForSaveImages.collectionName} collection</button>,
          "close",
        ] : ["close"],
      }}
      index={lightBoxImageIndex}
      slides={socialImages.map(im => ({ src: im.imageUrl }))}
      plugins={[Zoom, Thumbnails, Counter]}
      on={{ view: ({ index: currentIndex }) => setLightBoxImageIndex(currentIndex) }}
    />
    <Lightbox
      open={retailerlightBoxImageIndex != null}
      close={() => {
        setRetailerlightBoxImageIndex(null)
      }}
      toolbar={{
        buttons: userLoggedIn && userLoggedIn.curator && collectionForSaveImages && retailerlightBoxImageIndex != null ? [
          <button key="my-button" type="button"
            className={`yarl__button ${collectionForSaveImages &&
              collectionForSaveImages._id &&
              retailercollectionSets[collectionForSaveImages._id] &&
              retailercollectionSets[collectionForSaveImages._id].has(retailerImages[retailerlightBoxImageIndex % retailerImages.length]._id)
              ? 'bg-red-500' : 'bg-blue-600'}`}
            onClick={(e) => {
              retailerAddImageToCollectionWrapper(retailerImages[retailerlightBoxImageIndex % retailerImages.length], collectionForSaveImages._id)
            }}>{retailercollectionSets[collectionForSaveImages._id].has(retailerImages[retailerlightBoxImageIndex % retailerImages.length]._id) ? 'Unsave' : 'Save'} in {collectionForSaveImages.collectionName} collection</button>,
          "close",
        ] : ["close"],
      }}
      index={retailerlightBoxImageIndex}
      slides={retailerImages.map(im => ({ src: im.image_url }))}
      plugins={[Zoom, Thumbnails, Counter]}
      on={{ view: ({ index: currentIndex }) => setRetailerlightBoxImageIndex(currentIndex) }}
    />

  </div >


}
export default DesignRecipeImages
